export const DATEV_ERROR_DUPLICATE_FILE = '#DCO01253'

export const FinanceFormKeys = {
  exportDatev: 'exportDatev',
  exportDatevView: 'exportDatevView',
  export: 'export',
  exportList: 'exportList',
  zReportList: 'zReportList',
}
